"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminSchema = void 0;
const shared_1 = require("../shared");
const identity_user_schema_1 = require("./identity-user.schema");
exports.AdminSchema = identity_user_schema_1.BaseIdentitySchema.extend({ companyId: shared_1.UUIDSchema });
